import { render, staticRenderFns } from "./ToggleLanguage.vue?vue&type=template&id=768d24d3&"
import script from "./ToggleLanguage.vue?vue&type=script&lang=js&"
export * from "./ToggleLanguage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports